if ($('#request_holiday_brochure_agreement_wrap').hasClass('field-error')) {
    $('.contact-form__header--data').addClass('contact-form__header--error');
    var value = $('.contact-form__header--data').html();
    $('.contact-form__header--data').html(value + ' *');
}
